import { TFunction } from "i18next";
import * as Yup from "yup";

import { MultiDayFormValues } from "@/common/components/appointments/plan-attendance/PlanAttendanceDialog.types";

export function multiDayValidationSchema(t: TFunction): Yup.ObjectSchema<MultiDayFormValues> {
  return Yup.object({
    dateFrom: Yup.date()
      .nullable()
      .required(
        t("common.validation.fieldRequired", { fieldName: t("calendar.planAttendance.dateFrom") })
      ) as Yup.Schema<Date | null>,
    dateTo: Yup.date()
      .nullable()
      .required(t("common.validation.fieldRequired", { fieldName: t("calendar.planAttendance.dateTo") }))
      .test("date-to-after-from", t("calendar.planAttendance.dateToBeforeFrom"), function (dateTo) {
        const { dateFrom } = this.parent as Pick<MultiDayFormValues, "dateFrom">;
        if (!dateFrom) {
          return true;
        }
        return dateTo >= dateFrom;
      }) as Yup.Schema<Date | null>,
    purposeKey: Yup.string().required(
      t("common.validation.fieldRequired", { fieldName: t("calendar.planAttendance.purpose") })
    ),
    attendanceType: Yup.mixed().nullable().defined() as Yup.Schema<MultiDayFormValues["attendanceType"]>,
    note: Yup.string().optional() as Yup.Schema<string>,
    substituteCounselorId: Yup.string().nullable().defined() as Yup.Schema<string | null>,
  });
}
